import { PAGES } from "@/data/types/pages";

export const QRSlugPage = {
  url: "QR_URL",
  vcard: "QR_VCARD",
  social: "QR_SOCIAL",
  business: "QR_BUSINESS",
  apps: "QR_APPS",
  video: "QR_VIDEO",
  pdf: "QR_PDF",
  listoflinks: "QR_LISTOFLINKS",
  wifi: "QR_WIFI",
  image: "QR_IMAGE",
  youtube: "QR_YOUTUBE",
  website: "QR_WEBSITE",
  event: "QR_EVENT",
  coupon: "QR_COUPON",
  feedback: "QR_FEEDBACK",
  mp3: "QR_MP3",
  text: "QR_TEXT",
  email: "QR_EMAIL",
  ["url-static"]: "QR_URL_STATIC",
  sms: "QR_SMS",
  whatsapp: "QR_WHATSAPP",
};

export const pageData = (qrSlug: string): string => PAGES[QRSlugPage[qrSlug]];

export const isValidQRSlug = (qrSlug: string) => {
  const validQRSlug: string[] = Object.keys(QRSlugPage).map((key) => PAGES[QRSlugPage[key]]);
  return validQRSlug.includes(qrSlug);
};

export const getQrSlugs = () => {
  const qrSlugs: string[] = Object.keys(QRSlugPage).map((key) => PAGES[QRSlugPage[key]]);
  return qrSlugs;
};
